import type { Equipo } from "@/lib/equipos";
import { casaBool, casaID, casaIgual, casaTexto } from "@/lib/filtros/texto";

/** CLAVES_EQUIPOS son los parámetros que admite el listado de equipos (#247). */
export const CLAVES_EQUIPOS = ["area", "criticidad", "activo", "loteable", "estado", "q"] as const;

/** FiltrosEquipos es el objeto de filtros del listado de equipos tal como viaja en la URL. */
export type FiltrosEquipos = Partial<Record<(typeof CLAVES_EQUIPOS)[number], string>>;

/**
 * filtrarEquipos aplica los filtros en el navegador (modo sin red, D2). Debe dar el MISMO
 * resultado que el SQL del servidor: ver la tabla de casos compartida en
 * backend/internal/factory/filtros_integration_test.go (TestFiltrosEquiposHTTP).
 */
export function filtrarEquipos(filas: Equipo[], filtros: FiltrosEquipos): Equipo[] {
  return filas.filter(
    (e) =>
      casaID(filtros.area, e.id_area) &&
      casaIgual(filtros.criticidad, e.criticidad) &&
      casaBool(filtros.activo, e.activo) &&
      casaBool(filtros.loteable, e.loteable) &&
      // `estado` es la traducción publicada del booleano derivado (#243).
      casaIgual(filtros.estado, e.estado) &&
      // `q` alcanza también la relación ACTIVA que la propia fila publica (#289): el
      // código del candado que bloquea el equipo y el nombre del punto bloqueado, que es
      // lo mismo que pinta la columna «Bloqueo» (#248). Un bloqueo retirado no llega en
      // esos arrays, así que la ausencia sale sola.
      casaTexto(
        filtros.q,
        e.codigo_equipo,
        e.nombre_equipo,
        e.descripcion,
        ...e.candados.map((c) => c.codigo_candado),
        ...e.puntos_bloqueados.map((p) => p.nombre),
      ),
  );
}
